import { useContext } from 'react';
import { onMouseEnterContext } from './context';

export const useOnMouseEnter = () => {
  const onMouseEnter = useContext(onMouseEnterContext);
  return onMouseEnter;
};
